import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { UtensilsCrossed, RefreshCw, AlertTriangle, CheckCircle2 } from "lucide-react";

const eur = (n) => `${Number(n || 0).toFixed(2).replace(".", ",")} €`;

/** Come sta il menu di un cliente, letto dalla console: nessun accesso al suo gestionale. */
export const MenuLocale = ({ client, tenant }) => {
  const [d, setD] = useState(null);
  const [apri, setApri] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await client.get(`/admin/tenants/${tenant.id}/menu-check`);
      setD(r.data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Menu non leggibile");
    }
  }, [client, tenant.id]);

  useEffect(() => {
    load();
  }, [load]);

  if (!d) return null;
  const daSistemare = d.problemi.filter((p) => p.count > 0);

  return (
    <div className="space-y-3 rounded-md bg-slate-900/60 p-3" data-testid="menu-locale">
      <div className="flex items-center justify-between gap-2">
        <p className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.18em] text-slate-400">
          <UtensilsCrossed className="h-3.5 w-3.5" /> Com'è il menu ({d.totale} piatti)
        </p>
        <Button size="sm" variant="ghost" className="text-slate-400" onClick={load} data-testid="menu-locale-refresh">
          <RefreshCw className="h-3.5 w-3.5" />
        </Button>
      </div>

      {d.totale === 0 ? (
        <p className="text-xs text-amber-300" data-testid="menu-locale-vuoto">
          Menu vuoto: il locale non ha ancora caricato nessun piatto.
        </p>
      ) : (
        <>
          <div className="space-y-1" data-testid="menu-locale-categorie">
            {d.categorie.map((c) => (
              <p key={c.name} className="flex flex-wrap items-baseline gap-x-2 text-xs">
                <span className="font-semibold text-slate-200">{c.name}</span>
                <span className="font-num text-slate-400">{c.piatti} piatti</span>
                {c.prezzo_min != null && (
                  <span className="font-num text-slate-500">
                    {c.prezzo_min === c.prezzo_max ? eur(c.prezzo_min) : `${eur(c.prezzo_min)} – ${eur(c.prezzo_max)}`}
                  </span>
                )}
              </p>
            ))}
            {d.spenti > 0 && <p className="text-[11px] text-slate-500">{d.spenti} piatti spenti (non in carta)</p>}
          </div>

          {daSistemare.length === 0 ? (
            <p className="flex items-center gap-1.5 text-xs text-emerald-300" data-testid="menu-locale-ok">
              <CheckCircle2 className="h-3.5 w-3.5" /> Menu completo: prezzi, reparti e allergeni a posto.
            </p>
          ) : (
            <div className="space-y-1.5" data-testid="menu-locale-problemi">
              {daSistemare.map((pb) => (
                <div key={pb.id}>
                  <button
                    className="flex w-full items-center gap-1.5 text-left text-xs text-amber-300"
                    onClick={() => setApri(apri === pb.id ? null : pb.id)}
                    data-testid={`menu-problema-${pb.id}`}
                  >
                    <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
                    {pb.label}: <span className="font-num font-bold">{pb.count}</span>
                  </button>
                  {apri === pb.id && (
                    <p className="mt-1 pl-5 text-[11px] text-slate-400">
                      {pb.items.join(" · ")}
                      {pb.count > pb.items.length ? ` … e altri ${pb.count - pb.items.length}` : ""}
                    </p>
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};
